import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InvoicesComponent } from './invoices/invoices.component';
import { UploadComponent } from './upload/upload.component';
import { DetailComponent } from './detail/detail.component';
import { InvoiceResolver } from "../../resolver/invoice.resolver";

const routes: Routes = [
  {
    path: '',
    redirectTo: 'list',
  },
  {
    path: 'list',
    component: InvoicesComponent,
    data: {
      title: 'Invoices Page'
    },
  },
  {
    path: 'upload',
    component: UploadComponent,
    data: {
      title: 'Upload Page'
    },
  },
  {
    path: 'detail/:id',
    component: DetailComponent,
    resolve: {
      invoice: InvoiceResolver,
    },
    data: {
      title: 'Detail Page'
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class InvoicesRoutingModule { }



// WEBPACK FOOTER //
// /app/src/app/client/invoices/invoices-routing.module.ts